import * as Yup from "yup";
import { FormItemProps } from "@/components/Form/types";

interface RoleOption {
  label: string;
  value: string;
}

export const createUserFormItems = (roleOptions: RoleOption[] = []): Array<FormItemProps> => [
  {
    name: 'email',
    label: 'Username (Email)',
    placeholder: 'Enter email address',
    type: 'Text',
    defaultValue: null,
    validation: Yup.string()
      .email('Please enter a valid email address')
      .required('Email is required'),
    classNames: { container: 'col-span-12' },
    autoFocus: true,
  },
  {
    name: 'password',
    label: 'Password',
    placeholder: 'Enter password',
    type: 'Password',
    defaultValue: null,
    validation: Yup.string()
      .min(8, 'Password must be at least 8 characters')
      .required('Password is required'),
    classNames: { container: 'col-span-12' },
  },
  {
    name: 'roles',
    label: 'Roles',
    placeholder: 'Select roles',
    type: 'Select',
    defaultValue: [],
    validation: Yup.array().min(1, 'At least one role is required'),
    classNames: { container: 'col-span-12' },
    itemOptions: {
      list: roleOptions,
      features: {
        isMulti: true
      }
    }
  },
];

// Default export for backwards compatibility
const Items = createUserFormItems();
export default Items;
